module.exports = ":host form{height:0;overflow:hidden}\n"